export enum PaymentType {
    Cash = 'CASH',
    BankTransfer = 'BankTransfer',
    ZaloPay = 'ZaloPay',
    Payon = 'Payon',
    Momo = 'Momo',
    Vnpay = 'Vnpay',
    PosappCard = 'PosappCard'
}
